var _path, _path2, _path3, _g, _path4, _g2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 144,
    viewBox: "0 0 244 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.002 53.8488L61.9766 79.4512L76.1219 137.478C76.9067 140.697 80.1528 142.671 83.3722 141.886L176.739 119.126C179.958 118.341 181.932 115.095 181.147 111.875L167.002 53.8488Z",
    fill: "#F7F6FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.003 87.2373L113.025 111.894C113.757 114.932 117.473 116.125 119.833 114.064L140.719 95.9173C143.269 93.6931 142.265 89.4887 138.956 88.7021L112.075 82.1922C109.037 81.4598 106.298 84.1994 107.03 87.2373H107.003Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.611 40.0519L58.5859 65.6543L61.957 79.4829L166.982 53.8805L163.611 40.0519Z",
    fill: "#F7F6FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.8424 61.7168L60.5391 65.2054L72.8423 76.8574L87.1224 73.3688L74.8424 61.7168Z",
    fill: "#E3E0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.796 55.3887L86.5156 58.854L98.7956 70.5293L113.099 67.0406L100.796 55.3887Z",
    fill: "#E3E0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.729 42.7129L138.426 46.2015L150.729 57.8768L165.032 54.3881L152.729 42.7129Z",
    fill: "#E3E0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.78 49.0645L112.477 52.5298L124.78 64.205L139.06 60.7164L126.78 49.0645Z",
    fill: "#E3E0FB"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145.812 0.183403L51.6055 53.2012L58.5863 65.6053L152.793 12.5875L145.812 0.183403Z",
    fill: "#F7F6FC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1625 57.4648L60.3477 64.6979L61.3477 47.7665L74.1626 40.5566L73.1625 57.4648Z",
    fill: "#E3E0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.436 44.3633L83.6211 51.5731L84.6444 34.6649L97.4593 27.4551L96.436 44.3633Z",
    fill: "#E3E0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.026 18.1523L130.211 25.3622L131.234 8.45391L144.049 1.24414L143.026 18.1523Z",
    fill: "#E3E0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.744 31.2422L106.906 38.4753L107.93 21.5438L120.744 14.334L119.744 31.2422Z",
    fill: "#E3E0FB"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 214.043,
    cy: 83.9824,
    r: 4.5,
    fill: "#F7F6FC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 229.98,
    cy: 56.0723,
    r: 4.5,
    fill: "#F7F6FC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.9688,
    cy: 106.092,
    r: 4.5,
    fill: "#F7F6FC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.62891,
    cy: 126.256,
    r: 4.5,
    fill: "#F7F6FC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.332,
    cy: 61.7168,
    r: 4.5,
    fill: "#F7F6FC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.332,
    cy: 115.092,
    r: 4.5,
    fill: "#F7F6FC"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.62891,
    cy: 81.3574,
    r: 4.5,
    fill: "#F7F6FC"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5859,
    cy: 128.35,
    r: 4.5,
    fill: "#F7F6FC"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 238.98,
    cy: 98.584,
    r: 4.5,
    fill: "#F7F6FC"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.0859,
    cy: 85.8574,
    r: 4.5,
    fill: "#F7F6FC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoUpload);
export default __webpack_public_path__ + "static/media/videoUpload.6e715a60a525c4a9a7458b777fd7f3fb.svg";
export { ForwardRef as ReactComponent };